/**
 * Generated from ch3_p08.fla
 */
export function ch3_p08(this: Ich3_p08) {
	const bg = this.bg;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyGuitar = this.hollyGuitar;
	ch3_p08_hh_ch3_72dpi_p07psdAssetHolly.call(this.hollyGuitar);
	hollyGuitar.x = 746;
	hollyGuitar.y = 460;
	hollyGuitar.width = 467.00;
	hollyGuitar.height = 618.00;
	hollyGuitar.alpha = 1.00;
	if (hollyGuitar.onLayout) hollyGuitar.onLayout();
	const holly = this.holly;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_hollyguitar.call(this.holly);
	holly.x = 777;
	holly.y = 435.5;
	holly.width = 458.00;
	holly.height = 561.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeRframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesRight = this.linesRight;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartR.call(this.linesRight);
	linesRight.x = 77.5;
	linesRight.y = 358.25;
	linesRight.width = 77.50;
	linesRight.height = 626.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const linesLeft = this.linesLeft;
	ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartL.call(this.linesLeft);
	linesLeft.x = 1380;
	linesLeft.y = 365;
	linesLeft.width = 284.00;
	linesLeft.height = 730.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_bg(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p08_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p07psdAssetHolly(this: Ich3_p08_hh_ch3_72dpi_p07psdAssetHolly) {
	if (this.setLayoutTexture) this.setLayoutTexture("Holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_hollyguitar(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_hollyguitar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p08_hollyguitar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLframe(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeRframe(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartR(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartR) {
	if (this.setLayoutTexture) this.setLayoutTexture("LineartR", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartL(this: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartL) {
	if (this.setLayoutTexture) this.setLayoutTexture("LineartL", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
interface Ich3_p08Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich3_p08Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich3_p08Sprite extends Ich3_p08Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich3_p08Text extends Ich3_p08Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich3_p08Polygon extends Array<number> {
}
interface Ich3_p08 {
	readonly bg: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_bg;
	readonly hollyGuitar: Ich3_p08_hh_ch3_72dpi_p07psdAssetHolly;
	readonly holly: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_hollyguitar;
	readonly frameRight: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLframe;
	readonly frameLeft: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeRframe;
	readonly linesRight: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartR;
	readonly linesLeft: Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartL;
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_bg extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p07psdAssetHolly extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_hollyguitar extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLframe extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeRframe extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartR extends Ich3_p08Sprite {
}
interface Ich3_p08_hh_ch3_72dpi_p08psdAssetchp3_p08_wcframeLineartL extends Ich3_p08Sprite {
}
